import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'devextreme/dist/css/dx.light.css';
import { axiosGet } from './js/apiService';
import apiConsts from './js/apiConsts.js';
import { createVuestic } from "vuestic-ui";

export const app = createApp(App).use(createVuestic()).use(router)

app.config.globalProperties.$GenericError = false;
app.config.globalProperties.$strings = null;

//let url = "";

// axios.get(process.env.BASE_URL + "app.json")
//   .then((config) => {
//     url = config.data.APIWebServiceURL;

    axiosGet( apiConsts.APISTRINGS )
    .then((response) => {
        let strings = response.data;
        app.config.globalProperties.$strings = strings;
        app.mount("#app");
    })
    .catch(() => {
        app.config.globalProperties.$strings = null;
        app.mount("#app");
    });
  //});





